(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  // Header scroll state
  const header = $(".header");
  if (header) {
    const onScroll = () => header.classList.toggle("is-scrolled", window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  // Mobile menu drawer
  const menuBtn = $("[data-menu-toggle]");
  const mobileNav = $("[data-mobile-nav]");
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener("click", () => {
      const open = mobileNav.classList.toggle("open");
      menuBtn.setAttribute("aria-expanded", String(open));
      document.body.style.overflow = open ? "hidden" : "";
    });
  }

  // Currency formatter
  const money = (cents, withCode) => {
    try {
      return (cents / 100).toLocaleString("en-US", {
        style: "currency",
        currency: withCode || window.Shopify?.currency?.active || "USD",
        maximumFractionDigits: cents % 100 === 0 ? 0 : 2,
      });
    } catch {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  // Cart & Drawer DOM references
  const countEl = $("[data-cart-count]");
  const overlay = $("[data-overlay]");
  const drawer = $("[data-cart-drawer]");
  const drawerBody = $("[data-cart-body]");
  const drawerTotal = $("[data-cart-total]");

  // Filter Drawer DOM references
  const filterDrawer = $("[data-filter-drawer]");
  const filterOverlay = $("[data-filter-overlay]");

  // Quick Look Helper
  function closeQuickLook() {
    const qlModal = document.getElementById("QuickLookModal");
    if (qlModal) {
      qlModal.style.setProperty("display", "none", "important");
      qlModal.setAttribute("aria-hidden", "true");
      qlModal.classList.remove("is-active");
    }
  }

  function setCount(n) {
    if (!countEl) return;
    countEl.hidden = n < 1;
    countEl.textContent = String(n);
  }

  function openCart() {
    overlay?.classList.add("open");
    drawer?.classList.add("open");
    drawer?.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeCart() {
    overlay?.classList.remove("open");
    drawer?.classList.remove("open");
    drawer?.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function openFilter() {
    filterDrawer?.classList.add("is-active");
    filterOverlay?.classList.add("is-active");
    document.body.style.overflow = "hidden";
  }

  function closeFilter() {
    filterDrawer?.classList.remove("is-active");
    filterOverlay?.classList.remove("is-active");
    document.body.style.overflow = "";
  }

  // Cart Refresh Logic
  async function refreshCart() {
    try {
      const cart = await fetch("/cart.js").then((r) => r.json());
      setCount(cart.item_count);
      if (drawerTotal) drawerTotal.textContent = money(cart.total_price, cart.currency);
      if (!drawerBody) return;

      if (!cart.items.length) {
        drawerBody.innerHTML = `<div class="empty" style="padding:4rem 1rem"><h2>Your bag is empty</h2><p style="color:var(--muted)">Start with the new drop.</p><p><a class="btn btn-gold" href="/collections/all-products" data-close-cart>Shop now</a></p></div>`;
        return;
      }

      drawerBody.innerHTML = cart.items
        .map(
          (item) => `
        <div class="cart-line">
          <img src="${item.image ? item.image.replace(/(\.[^.]*)$/, "_200x$1") : ""}" alt="${item.title || ""}">
          <div style="flex:1;min-width:0">
            <a href="${item.url}">${item.product_title}</a>
            <p style="color:var(--muted);font-size:12px;margin:.25rem 0 0">${item.variant_title || ""}</p>
            <div style="display:flex;justify-content:space-between;margin-top:1rem;align-items:center">
              <span>Qty: ${item.quantity}</span>
              <span>${money(item.final_line_price, cart.currency)}</span>
            </div>
            <button type="button" class="icon-btn" data-remove="${item.key}" aria-label="Remove" style="width:auto;height:auto;padding:0;color:var(--muted);margin-top:0.5rem">Remove</button>
          </div>
        </div>`,
        )
        .join("");
    } catch (err) {
      console.error("Cart update failed:", err);
    }
  }

  // Delegated Click Handlers
  document.addEventListener("click", async (e) => {
    const t = e.target.closest("[data-open-cart], [data-close-cart], [data-remove], [data-open-search], [data-close-search], [data-open-filter], [data-close-filter], [data-thumb]");
    if (!t) return;

    if (t.hasAttribute("data-open-cart")) {
      e.preventDefault();
      await refreshCart();
      openCart();
    }
    if (t.hasAttribute("data-close-cart")) closeCart();

    if (t.hasAttribute("data-remove")) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: t.getAttribute("data-remove"), quantity: 0 }),
      });
      await refreshCart();
    }

    if (t.hasAttribute("data-open-search")) {
      e.preventDefault();
      $("[data-search-modal]")?.classList.add("open");
      $("[data-search-input]")?.focus();
    }
    if (t.hasAttribute("data-close-search")) $("[data-search-modal]")?.classList.remove("open");

    if (t.hasAttribute("data-open-filter")) {
      e.preventDefault();
      openFilter();
    }
    if (t.hasAttribute("data-close-filter")) closeFilter();

    if (t.hasAttribute("data-thumb")) {
      const main = $("[data-main-image]");
      if (main && t.dataset.thumb) main.src = t.dataset.thumb;
      $$("[data-thumb]").forEach((b) => b.classList.remove("is-active"));
      t.classList.add("is-active");
    }
  });

  overlay?.addEventListener("click", closeCart);
  filterOverlay?.addEventListener("click", closeFilter);

  // Close modals on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeCart();
      closeFilter();
      closeQuickLook();
      $("[data-search-modal]")?.classList.remove("open");
      if (mobileNav?.classList.contains("open")) {
        mobileNav.classList.remove("open");
        menuBtn?.setAttribute("aria-expanded", "false");
        document.body.style.overflow = "";
      }
    }
  });

  // Delegated Product Form Submit (Ajax Add-to-Cart)
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest("[data-product-form]");
    if (!form) return;
    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    try {
      const data = new FormData(form);
      await fetch("/cart/add.js", { method: "POST", body: data });
      await refreshCart();
      openCart();
    } catch (err) {
      console.error("Error adding to cart:", err);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });

  // Predictive Live Search
  const searchInput = $("[data-search-input]");
  const searchResults = $("[data-search-results]");
  let timer;
  searchInput?.addEventListener("input", () => {
    clearTimeout(timer);
    const q = searchInput.value.trim();
    if (q.length < 2) {
      if (searchResults) searchResults.innerHTML = "";
      return;
    }
    timer = setTimeout(async () => {
      try {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`).then((r) => r.json());
        const products = res.resources?.results?.products || [];
        if (!searchResults) return;
        searchResults.innerHTML = products
          .map(
            (p) =>
              `<a href="${p.url}"><img src="${p.image || ""}" alt=""><span style="flex:1;font-family:var(--font-display);font-size:1.1rem">${p.title}</span></a>`,
          )
          .join("") || `<p style="color:var(--muted);padding:1rem 0">No matches.</p>`;
      } catch (err) {
        console.error("Search suggestion error:", err);
      }
    }, 200);
  });

  // Dynamic Variant Switcher (Image, Price, Compare Price, Availability)
  document.addEventListener("change", (e) => {
    const target = e.target;
    const form = target.closest("[data-product-form]") || target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const productUrl = form.dataset.productUrl || window.location.pathname;
    const productPath = productUrl.replace(/\/$/, "") + ".js";

    fetch(productPath)
      .then((res) => res.json())
      .then((product) => {
        const selectId = form.querySelector('[name="id"]')?.value;
        if (!selectId) return;

        const currentVariant = product.variants.find((v) => v.id == selectId);

        if (currentVariant) {
          if (currentVariant.featured_image) {
            const mainImg = $("[data-main-image]");
            if (mainImg) mainImg.src = currentVariant.featured_image.src;
          }

          const priceEl = $("[data-product-price]") || $("[data-price]");
          if (priceEl && currentVariant.price !== undefined) {
            priceEl.textContent = money(currentVariant.price);
          }

          const compareEl = $("[data-compare-price]");
          if (compareEl) {
            if (currentVariant.compare_at_price > currentVariant.price) {
              compareEl.textContent = money(currentVariant.compare_at_price);
              compareEl.style.display = "";
            } else {
              compareEl.style.display = "none";
            }
          }

          const submitBtn = form.querySelector('[type="submit"]');
          if (submitBtn) {
            if (currentVariant.available) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitBtn.dataset.addText || "Add to Bag";
            } else {
              submitBtn.disabled = true;
              submitBtn.textContent = "Sold Out";
            }
          }
        }
      })
      .catch(() => {});
  });

  // Collection Facet Form Auto-submit & Disclosures
  const facetForm = $(".facets__form");
  if (facetForm) {
    facetForm.addEventListener("change", () => {
      facetForm.submit();
    });
  }

  document.addEventListener("click", (event) => {
    $$(".facets__disclosure[open]").forEach((disclosure) => {
      if (!disclosure.contains(event.target)) {
        disclosure.removeAttribute("open");
      }
    });
  });

  const disclosures = $$(".facets__disclosure");
  disclosures.forEach((disclosure) => {
    const summary = $("summary", disclosure);
    if (summary) {
      summary.addEventListener("click", () => {
        disclosures.forEach((other) => {
          if (other !== disclosure) other.removeAttribute("open");
        });
      });
    }
  });

  // Initial cart load
  refreshCart().catch(() => {});
})();